import React from 'react'
import PreviewPaneComponent from './PreviewPaneComponent'


function PreviewPane(props) {
    const { className, setKeywords, geos, geoLocations, setGeoLocations } = props

    const paneComponents = [
        {
            title: "Keywords",
            size: "lg",
            itemsList: props.keywords.split("\n").map(i => i.trim()).filter(i => i?.length),
            updateItems: keywordsList => setKeywords(keywordsList.join("\n"))
        }, {
            title: "Taxonomy categories",
            size: "lg",
            itemsList: props.taxonomies,
            colSize: 12
        },{
            title: "Languages",
            size: "sm",
            itemsList: props.languages,
            updateItems: props.setLanguages
        },{
            title: "Emotions",
            size: "sm",
            itemsList: props.emotions,
            updateItems: props.setEmotions
        }, {
            title: "Intents",
            size: "md",
            itemsList: props.intents,
            updateItems: props.setIntents,
            colSize: 4
        },{
            title: "Candidates",
            size: "md",
            itemsList: props.candidate,
            updateItems: props.setCandidate,
            colSize: 4
        },{
            title: "Domains_Blacklist",
            size: "md",
            itemsList: props.domainsblacklist,
            updateItems: props.setDomainsBlacklist,
            colSize: 4
        },{
            title: "Domains_Whitelist",
            size: "md",
            itemsList: props.domainswhitelist,
            updateItems: props.setDomainsWhitlist,
            colSize: 4
        },{
            title: "Sensational-Fact-Based",
            size: "md",
            itemsList: props.sensationalfactbased,
            updateItems: props.setSensationalFactBased,
            colSize: 4
        },{
            title: "Liberal-Conservative",
            size: "md",
            itemsList: props.liberalconservative,
            updateItems: props.setLiberalConservative,
            colSize: 4
        },
    ]

    return (
        <div className='col-4 p-0 output-view rounded'>
            <div className={ `${className} ${["keywords", "taxonomies", "emotions", "languages", "candidate", "intents",  "domainsblacklist", "domainswhitelist", "liberalconservative", "sensationalfactbased" ].some(item => props[item]?.length) || "d-none"}` }>
                {
                    paneComponents.slice(0, 2).map(paneComponent => (
                        <PreviewPaneComponent { ...paneComponent } />
                    ))
                }
                <div className='h-50'>
                    {
                        paneComponents.slice(2).map(paneComponent => (
                            <PreviewPaneComponent { ... paneComponent } />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default PreviewPane
